import { gql } from '@lcs/shared/api';

export const getScheduleDetail = gql`
   query GetScheduleDetail($id: UInt!) {
      schedule(id: $id) {
         scheduleId
         accountId
         name
         description
         scheduleDetailsConnection {
            items {
               scheduleDetailId
               scheduleId
               dayOfWeek
               openTime
               closeTime
            }
         }
         closedExceptionsConnection {
            items {
               closedExceptionId
               scheduleId
               startDate
               endDate
               startTime
               endTime
               prompt {
                  promptId
                  name
               }
            }
         }
         phoneNumbersConnection {
            items {
               phoneNumberId
               scheduleId
               displayName
               phoneNumber
               phoneNumberStatus
            }
         }
         createDate
         createUser {
            userId
            name
         }
         updateDate
         updateUser {
            userId
            name
         }
         account {
            accountId
            name
            scheduleId
         }
      }
   }
`;

export const getPhoneNumbersUsingDefaultSchedule = gql`
   query GetPhoneNumbersUsingSchedule($filter: String!) {
      phoneNumbersConnection(filters: $filter) {
         items {
            phoneNumberId
            scheduleId
            displayName
            phoneNumber
            phoneNumberStatus
         }
      }
   }
`;
